module.exports = __webpack_public_path__ + "static/media/DK_Feature.855ef594.png";